import React from 'react';
import { Card } from './ui/Card';
import { ScoreRing } from './ui/ScoreRing';
import { PhoneCall } from 'lucide-react';
interface CallReviewCardProps {
  highlighted?: boolean;
}
export function CallReviewCard({
  highlighted
}: CallReviewCardProps) {
  return <Card delay={0.3} highlighted={highlighted} data-id="element-70">
      <div className="flex items-center justify-between mb-6" data-id="element-71">
        <h2 className="text-2xl text-navy flex items-center gap-2" data-id="element-72">
          <PhoneCall className="text-crimson" size={24} data-id="element-73" />
          Call Review
        </h2>
        <ScoreRing score={8} size="sm" dynamicColor data-id="element-74" />
      </div>

      <div className="space-y-6" data-id="element-75">
        <div data-id="element-76">
          <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-77">
            Summary
          </h3>
          <p className="text-sm text-gray-700 leading-relaxed" data-id="element-78">
            The call was focused on discussing options for taking cash out of
            the client's home. The agent provided information on HELOC and
            cash-out refinance options, and the client expressed interest in
            proceeding with the HELOC option.
          </p>
        </div>

        <div className="border-t border-warmgray pt-4" data-id="element-79">
          <dl className="grid grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-2" data-id="element-80">
            <div className="sm:col-span-1" data-id="element-81">
              <dt className="text-xs font-medium text-gray-500" data-id="element-82">
                Call Reception Score
              </dt>
              <dd className="mt-1 text-sm text-navy font-serif text-lg" data-id="element-83">9</dd>
            </div>
            <div className="sm:col-span-1" data-id="element-84">
              <dt className="text-xs font-medium text-gray-500" data-id="element-85">
                Loan Options Requested
              </dt>
              <dd className="mt-1 text-sm text-gray-800" data-id="element-86">
                HELOC with interest-only option
              </dd>
            </div>
            <div className="sm:col-span-1" data-id="element-87">
              <dt className="text-xs font-medium text-gray-500" data-id="element-88">
                Loan Options Pitched
              </dt>
              <dd className="mt-1 text-sm text-gray-800" data-id="element-89">
                HELOC, Cash-out refinance
              </dd>
            </div>
            <div className="sm:col-span-1" data-id="element-90">
              <dt className="text-xs font-medium text-gray-500" data-id="element-91">
                Client Objections
              </dt>
              <dd className="mt-1 text-sm text-gray-800" data-id="element-92">
                Client was concerned about the lack of interest-only option for
                HELOC.
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </Card>;
}